import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { MessageType } from "./ConnectionMessage";
import { ArgumentNullError, InvalidOperationError } from "./Error";
import { createNoDashGuid } from "./Guid";
export var RawWebsocketMessage = /*#__PURE__*/function () {
  function RawWebsocketMessage(messageType, payload, id) {
    _classCallCheck(this, RawWebsocketMessage);

    this.privPayload = null;

    if (!payload) {
      throw new ArgumentNullError("payload");
    }

    if (messageType === MessageType.Binary && !(payload instanceof ArrayBuffer)) {
      throw new InvalidOperationError("Payload must be ArrayBuffer");
    }

    if (messageType === MessageType.Text && !(typeof payload === "string")) {
      throw new InvalidOperationError("Payload must be a string");
    }

    this.privMessageType = messageType;
    this.privPayload = payload;
    this.privId = id ? id : createNoDashGuid();
  }

  _createClass(RawWebsocketMessage, [{
    key: "messageType",
    get: function get() {
      return this.privMessageType;
    }
  }, {
    key: "payload",
    get: function get() {
      return this.privPayload;
    }
  }, {
    key: "textContent",
    get: function get() {
      if (this.privMessageType === MessageType.Binary) {
        throw new InvalidOperationError("Not supported for binary message");
      }

      return this.privPayload;
    }
  }, {
    key: "binaryContent",
    get: function get() {
      if (this.privMessageType === MessageType.Text) {
        throw new InvalidOperationError("Not supported for text message");
      }

      return this.privPayload;
    }
  }, {
    key: "id",
    get: function get() {
      return this.privId;
    }
  }]);

  return RawWebsocketMessage;
}();